import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    obj: {
      A: "12",
      B: 23,
      C: {
        P: 23,
        O: {
          L: 56,
        },
        Q: [1, 2],
      },
    },
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { obj } = test;
      let outcome1 = output()(obj);
      let outcome2 = Solution(obj);
      const result = compare(outcome1, outcome2);
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
